import {
  PickersDay as BasePickersDay,
  PickersDayProps as BasePickersDayProps,
} from '@mui/x-date-pickers';
import { isSameDay } from 'date-fns';

import { ColoredDates } from '../../types';

export function PickersDay(
  props: BasePickersDayProps & {
    coloredDates?: ColoredDates;
    readOnly?: boolean;
  }
) {
  const {
    coloredDates = [],
    day,
    outsideCurrentMonth,
    readOnly,
    ...other
  } = props;

  const color = coloredDates.find((v) => isSameDay(day, v.date))?.color;

  return (
    <BasePickersDay
      {...other}
      disableRipple
      disableTouchRipple
      day={day}
      focusRipple={false}
      isAnimating={false}
      outsideCurrentMonth={outsideCurrentMonth}
      selected={false}
      sx={{
        color: color?.default,
        fontSize: 16,
        fontWeight: 500,
        pointerEvents: readOnly ? 'none' : 'auto',

        '&:hover': {
          color: color?.hover,
        },
      }}
    />
  );
}
